<template>
<div id="app">
  <router-view />
</div>
</template>

<script>
export default {
    name: 'App',
    metaInfo: { },
    components: { },
    data(){
      return{
        isLogged : false,
        user: null,
      }
    },
    beforeMount() {
      if(this.isLogged==false){
        this.user = JSON.parse(localStorage.getItem("userToken"));
        if(this.user!==null){ 
          this.isLogged =true;
          
        }else{
          this.$router.push('login');
        }
      }
    },
    beforeCreate(){ },
    created(){ },
    mounted(){ },
    methods: {
      
      setLogged(val,user) {
        this.user = user;
        this.isLogged = val;
      },
    },
  }
</script>

<style>
body,html { background-color: #171a1e; margin:0; color:#fff;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a {  text-decoration: none; }
* { box-sizing: border-box;}
</style>
